<script setup lang="ts">
import QuickLink from '@/components/dashboard/QuickLink.vue';
import QuickStats from '@/components/dashboard/QuickStats.vue';
import RecentSessions from '@/components/dashboard/RecentSessions.vue';
import Container from '@/layouts/Container.vue';

definePage({
  name: 'home',
});
</script>

<template>
  <Container>
    <template #title>
      Dashboard
    </template>

    <!-- Quick Stats Section -->
    <QuickStats />

    <!-- Recent Sessions Section -->
    <RecentSessions />

    <!-- Quick Actions -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
      <QuickLink
        to="/upload"
        title="Upload New Session"
        description="Upload and analyze your latest golf session data"
      />
      <QuickLink
        to="/sessions"
        title="View All Sessions"
        description="Access detailed analysis of your previous sessions"
      />
    </div>
  </Container>
</template>

<style scoped>
.dashboard-container {
  max-width: 1200px;
}
</style>
